(() => {
  const header = document.querySelector('.header');
  const burger = document.querySelector('.header__burger');
  const drawer = document.getElementById('drawer');
  const wa = document.querySelector('.wa');
  const footer = document.querySelector('.footer');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* mobile menu */
  if (burger && drawer) {
    const setMenu = (open) => {
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'סגירת תפריט' : 'פתיחת תפריט');
      drawer.hidden = !open;
    };
    burger.addEventListener('click', () => setMenu(burger.getAttribute('aria-expanded') !== 'true'));
    drawer.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });
  }

  /* header hairline once scrolled */
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* WhatsApp pill steps aside over the footer, where the contact links already are */
  if (wa && footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => wa.classList.toggle('is-hidden', entry.isIntersecting), { threshold: 0.15 })
      .observe(footer);
  }

  /* collections slideshow: crossfade, pausable, swipeable, stops for keyboard focus and reduced motion */
  document.querySelectorAll('.slides').forEach((slidesEl) => {
    const slides = [...slidesEl.querySelectorAll('.slide')];
    if (slides.length < 2) return;
    const dots = [...slidesEl.querySelectorAll('.slides__dot')];
    const pauseBtn = slidesEl.querySelector('.slides__pause');
    const every = Number(slidesEl.dataset.interval) || 4000;
    let i = 0, timer = null, userPaused = reduced;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        s.querySelectorAll('a').forEach((a) => { a.tabIndex = on && !a.classList.contains('slide__prod') ? 0 : -1; });
      });
      dots.forEach((d, k) => { d.classList.toggle('is-on', k === i); d.toggleAttribute('aria-current', k === i); });
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { stop(); if (!userPaused) timer = setInterval(() => go(i + 1), every); };
    const setPaused = (p) => {
      userPaused = p;
      pauseBtn.setAttribute('aria-pressed', String(p));
      pauseBtn.setAttribute('aria-label', p ? 'הפעלת ההחלפה האוטומטית' : 'עצירת ההחלפה האוטומטית');
      start();
    };
    slidesEl.querySelectorAll('.slides__arrow').forEach((b) => b.addEventListener('click', () => { go(i + Number(b.dataset.dir)); start(); }));
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); start(); }));
    pauseBtn.addEventListener('click', () => setPaused(!userPaused));
    slidesEl.addEventListener('focusin', stop);
    slidesEl.addEventListener('focusout', start);
    let x0 = null;
    slidesEl.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    slidesEl.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx > 0 ? 1 : -1)); start(); } // RTL: swipe right = next
      x0 = null;
    });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    go(0);
    setPaused(userPaused);
  });

  /* product gallery */
  const main = document.getElementById('pdp-main');
  const thumbs = [...document.querySelectorAll('.pdp__thumb')];
  const showMedia = (t) => {
    if (!main || !t) return;
    main.removeAttribute('srcset');
    main.src = t.dataset.src;
    main.alt = t.dataset.alt;
    thumbs.forEach((x) => { x.classList.toggle('is-on', x === t); x.setAttribute('aria-pressed', String(x === t)); });
  };
  thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t)));

  /* quantity steppers (product + cart) */
  document.querySelectorAll('[data-qty]').forEach((box) => {
    const input = box.querySelector('input');
    box.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => {
      const min = Number(input.min || 0);
      const max = input.max ? Number(input.max) : Infinity;
      input.value = Math.min(max, Math.max(min, Number(input.value || 0) + Number(b.dataset.step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  /* cart page: quantity changes save themselves */
  const cartForm = document.getElementById('cart-form');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', (e) => {
      if (!e.target.matches('[data-autosubmit]')) return;
      clearTimeout(t);
      t = setTimeout(() => cartForm.submit(), 450);
    });
  }

  /* collection sort */
  const sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* money */
  const money = (cents) => {
    const fmt = (window.KARINA && KARINA.moneyFormat) || '₪{{amount}}';
    const n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  /* product form: variants + add to cart without leaving the page */
  const form = document.querySelector('[data-product-form]');
  if (form) {
    const idInput = form.querySelector('[data-variant-id]');
    const addBtns = [...document.querySelectorAll('[data-add]')];
    const addLabels = [...document.querySelectorAll('[data-add-label]')];
    const setAdd = (text, disabled) => {
      addLabels.forEach((l) => { l.textContent = text; });
      addBtns.forEach((b) => { b.disabled = disabled; });
    };
    const err = form.querySelector('[data-form-error]');
    const priceEl = document.querySelector('[data-price]');
    const variantsEl = form.querySelector('[data-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

    if (variants.length) {
      form.addEventListener('change', (e) => {
        if (!e.target.matches('[data-option-index]')) return;
        const chosen = [...form.querySelectorAll('[data-option-index]:checked')].map((r) => r.value);
        const v = variants.find((x) => x.options.every((o, k) => o === chosen[k]));
        if (!v) { setAdd('לא זמין', true); return; }
        idInput.value = v.id;
        setAdd(v.available ? 'הוספה לסל' : 'אזל מהמלאי', !v.available);
        if (priceEl) priceEl.innerHTML = v.price ? `<span class="price">${money(v.price)}</span>` + (v.compare_at_price > v.price ? `<s class="price__was">${money(v.compare_at_price)}</s>` : '') : priceEl.innerHTML;
        const stickyPrice = document.querySelector('.pdp-sticky__price');
        if (stickyPrice && v.price) stickyPrice.textContent = money(v.price);
        if (v.featured_media) showMedia(thumbs.find((t) => t.dataset.mediaId === String(v.featured_media.id)));
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      });
    }

    form.addEventListener('submit', async (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      err.hidden = true;
      const label = addLabels[0] ? addLabels[0].textContent : 'הוספה לסל';
      setAdd('מוסיפה לסל…', true);
      try {
        const res = await fetch(KARINA.routes.cartAdd + '.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'משהו השתבש, נסי שוב');
        const cart = await (await fetch(KARINA.routes.cart + '.js')).json();
        document.querySelectorAll('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
        toast(`<span>${data.product_title || 'הפריט'} נוסף לסל</span><a href="${KARINA.routes.cart}">לסל הקניות</a>`);
        updateShipNudge(cart.total_price);
        setAdd('נוסף ✓', true);
        setTimeout(() => setAdd(label, false), 1600);
      } catch (ex) {
        err.textContent = ex.message;
        err.hidden = false;
        setAdd(label, false);
      }
    });
  }

  /* free-shipping nudge on the product page, refreshed from the real cart total */
  function updateShipNudge(total) {
    const box = document.querySelector('[data-ship-nudge]');
    if (!box) return;
    const threshold = Number(box.dataset.threshold) || 0;
    const left = threshold - total;
    box.classList.toggle('is-free', left <= 0);
    box.querySelector('[data-ship-text]').innerHTML = left <= 0
      ? '<b>המשלוח עלינו!</b> ההזמנה שלך זכאית למשלוח חינם'
      : `חסרים רק <b>${money(left)}</b> למשלוח חינם · <a href="${KARINA.routes.all || '/collections/all'}">להשלמת ההזמנה</a>`;
    box.querySelector('[data-ship-bar]').style.width = `${Math.min(100, Math.round((total / threshold) * 100))}%`;
  }

  /* mobile: the buy bar shows whenever the real button is off screen (also on the first screen, before it), and steps aside over the footer */
  const sticky = document.querySelector('[data-sticky]');
  const buy = document.querySelector('.pdp__buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    let buyVisible = true, footVisible = false;
    const sync = () => {
      const on = !buyVisible && !footVisible;
      sticky.classList.toggle('is-on', on);
      sticky.inert = !on;
    };
    new IntersectionObserver(([e]) => { buyVisible = e.isIntersecting; sync(); }).observe(buy);
    if (footer) new IntersectionObserver(([e]) => { footVisible = e.isIntersecting; sync(); }).observe(footer);
  }

  /* "where will it sit?" opens the size panel and brings it into view */
  document.querySelectorAll('[data-open-size]').forEach((b) => b.addEventListener('click', () => {
    const d = document.getElementById('pdp-size');
    if (!d) return;
    d.open = true;
    d.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  }));

  /* footer "cookie settings": reopens Shopify's consent banner */
  const cookieBtn = document.querySelector('[data-cookie-prefs]');
  if (cookieBtn) {
    const ready = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    const reveal = () => { if (ready()) cookieBtn.hidden = false; };
    reveal();
    window.addEventListener('load', reveal);
    document.addEventListener('visitorConsentCollected', reveal);
    cookieBtn.addEventListener('click', () => { if (ready()) window.privacyBanner.showPreferences(); });
  }

  let toastTimer;
  function toast(html) {
    const el = document.getElementById('toast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 5000);
  }

  /* quiet reveals */
  if (!('IntersectionObserver' in window) || reduced) return;
  const targets = document.querySelectorAll('.section__head, .cats, .products, .banner, .about__text, .trust, .insta__grid, .footer__club, .lookbook__intro, .lb, .statement__text, .story, .values, .care');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  targets.forEach((el) => {
    if (el.getBoundingClientRect().top < innerHeight) return; // already on screen: never hide it
    el.classList.add('reveal');
    io.observe(el);
  });
})();
